/**
 * Policy tag categories — centralised constant.
 * Used by: LoanProductForm (admin tag editor), CustomerPortal (customer filter UI)
 * Mirrors: backend/services/shared/constants.py POLICY_TAG_CATEGORIES
 */
export const POLICY_TAG_CATEGORIES: Record<string, { label: string; tags: { value: string; label: string }[] }> = {
  employment: {
    label: 'Employment Type',
    tags: [
      { value: 'payg', label: 'PAYG (Salary)' },
      { value: 'self_employed_2yr', label: 'Self-Employed 2+ Years' },
      { value: 'self_employed_1yr', label: 'Self-Employed 1 Year' },
      { value: 'contractor', label: 'Contractor' },
      { value: 'casual', label: 'Casual' },
      { value: 'probation', label: 'On Probation' },
    ],
  },
  profession_specials: {
    label: 'Professional Specials',
    tags: [
      { value: 'medical_professional', label: 'Medical Professional' },
      { value: 'legal_professional', label: 'Legal Professional' },
      { value: 'accounting', label: 'Accounting' },
      { value: 'defence_force', label: 'Defence Force' },
      { value: 'first_responder', label: 'First Responder' },
    ],
  },
  property: {
    label: 'Property Type',
    tags: [
      { value: 'house', label: 'House' },
      { value: 'unit_over_50sqm', label: 'Unit (over 50sqm)' },
      { value: 'unit_under_50sqm', label: 'Unit (under 50sqm)' },
      { value: 'townhouse', label: 'Townhouse' },
      { value: 'rural', label: 'Rural Property' },
      { value: 'smsf_residential', label: 'SMSF Residential' },
      { value: 'smsf_commercial', label: 'SMSF Commercial' },
      { value: 'vacant_land', label: 'Vacant Land' },
      { value: 'construction', label: 'Construction' },
    ],
  },
  loan_purpose: {
    label: 'Loan Purpose',
    tags: [
      { value: 'owner_occupied', label: 'Owner Occupied' },
      { value: 'investment', label: 'Investment' },
      { value: 'refinance', label: 'Refinance' },
      { value: 'first_home_buyer', label: 'First Home Buyer' },
      { value: 'bridging', label: 'Bridging Loan' },
      { value: 'construction', label: 'Construction' },
      { value: 'debt_consolidation', label: 'Debt Consolidation' },
    ],
  },
  credit_history: {
    label: 'Credit History',
    tags: [
      { value: 'clean', label: 'Clean Credit' },
      { value: 'minor_blemishes', label: 'Minor Blemishes' },
      { value: 'defaults_paid', label: 'Defaults (Paid)' },
      { value: 'non_conforming', label: 'Non-Conforming' },
      { value: 'discharged_bankrupt', label: 'Discharged Bankrupt' },
    ],
  },
  residency: {
    label: 'Residency Status',
    tags: [
      { value: 'citizen', label: 'Australian Citizen' },
      { value: 'permanent_resident', label: 'Permanent Resident' },
      { value: 'visa_482', label: 'Visa 482 (TSS)' },
      { value: 'visa_491', label: 'Visa 491 (Skilled Regional)' },
      { value: 'temp_visa_other', label: 'Temporary Visa (Other)' },
      { value: 'non_resident', label: 'Non-Resident' },
    ],
  },
  income_type: {
    label: 'Income Type',
    tags: [
      { value: 'salary', label: 'Salary' },
      { value: 'bonus_overtime', label: 'Bonus / Overtime' },
      { value: 'rental_income', label: 'Rental Income' },
      { value: 'trust_distributions', label: 'Trust Distributions' },
      { value: 'company_profits', label: 'Company Profits' },
      { value: 'foreign_income', label: 'Foreign Income' },
    ],
  },
  government_schemes: {
    label: 'Government Schemes',
    tags: [
      { value: 'fhog_eligible', label: 'FHOG Eligible' },
      { value: 'fhbg_eligible', label: 'FHBG Eligible' },
      { value: 'stamp_duty_exempt', label: 'Stamp Duty Exempt' },
      { value: 'help_to_buy', label: 'Help to Buy' },
    ],
  },
}

/** Categories shown as dropdowns in customer filter UI */
export const CUSTOMER_FILTER_CATEGORIES = ['employment', 'property', 'loan_purpose', 'residency', 'credit_history'] as const

/** Categories shown as checkboxes in customer filter UI */
export const CUSTOMER_CHECKBOX_CATEGORIES = ['profession_specials', 'government_schemes', 'income_type'] as const
